import script from "./release-results-button.vue?vue&type=script&lang=js"
export * from "./release-results-button.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__